import React from 'react'
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import { ImageStyle } from 'stylecomponents';
import CupoyImage from 'components/commons/CupoyImage';

const Container = GlobalStyle.BasicBlock.extend`
`

const Header = styled.div`
  font-size: 20px;
  color: #4A4A4A;
  border-bottom: solid 1px #D9D9D9;
  padding: 14px 16px 11px;
`

const ImgWrapper = styled.div`
  padding: 16px;
`

const BlockImg = ImageStyle.extend`
  height: 158px;
`

export default props => {
  return (
    <div>
      <Container>
        <Header>遊戲：{props.title}</Header>
        <ImgWrapper>
          <CupoyImage
            src={props.img}
            stylecomponent={BlockImg}
            isBackgroundImage
          />
        </ImgWrapper>
      </Container>
    </div>
  )
}
